class CommandGripperModel {

    toString() {
        return '';
    }
}

export default CommandGripperModel;
